export default "__VITE_ASSET__BgSyod_i__"